import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import SEOHead from "@/components/SEOHead";

const Goodbye = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const firstName = (location.state as { firstName?: string } | null)?.firstName;

  return (
    <>
      <SEOHead title="Goodbye — Dearestly." description="Your Dearestly. account has been deleted. Thank you for being part of Dearestly." path="/goodbye" noindex />
      <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ backgroundColor: "hsl(37 26% 91%)" }}>
      <div className="max-w-md text-center space-y-6">
        <div className="text-5xl">💛</div>
        <h1 className="font-serif text-2xl font-bold text-foreground">
          Goodbye{firstName ? `, ${firstName}` : ""}.
        </h1>
        <p className="font-serif italic text-base text-muted-foreground leading-relaxed">
          Thank you for being part of Dearestly
          <br />
          We hope you show up beautifully
          <br />
          for the people who matter to you.
        </p>
        <p className="text-sm text-muted-foreground mt-6">— Adeola &amp; the Dearestly team</p>
        <Button
          variant="outline"
          className="rounded-full mt-8"
          onClick={() => navigate("/")}
        >
          Back to homepage
        </Button>
      </div>
    </div>
  </>
  );
};

export default Goodbye;
